/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-reservation': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(8 6)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M9.789 16.625H6.21a.2.2 0 00-.198.176A1.99 1.99 0 008 19a1.99 1.99 0 001.987-2.2.198.198 0 00-.198-.176z"/><path pid="1" d="M15.557 15.26a12.847 12.847 0 01-1.397-5.804v-.608a7.192 7.192 0 00-3.093-6.034A5.135 5.135 0 009.2 2.087v-.9C9.2.532 8.663 0 8 0c-.663 0-1.2.532-1.2 1.188v.91a5.418 5.418 0 00-2.28 1.01 7.253 7.253 0 00-2.68 5.74v.608A12.847 12.847 0 01.443 15.26a.392.392 0 00.017.385.4.4 0 00.34.188h14.4a.4.4 0 00.34-.188.392.392 0 00.017-.386v.001z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-reservation.js